import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconCustomEmoovz = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Emoovz'
  size = size ?? 16
  color = color ?? theme.colors.contentPrimary

  return (
    <Icon viewBox='0 0 24 24' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>

      <circle cx="8" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2"/>
      <circle cx="16" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2"/>

      <path
        d="M11 12 L13 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  )
}

IconCustomEmoovz.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconCustomEmoovz